export default "<p>despliegue works!</p>\n"